import React from 'react';

import { useRouteWorkspace } from '../../contexts/RouteWorkspaceContext';
import GeneralSettings from '../settings/workspace/GeneralSettings';
import WorkspaceBackgroundPicker from './WorkspaceBackgroundPicker';

const WorkspaceSettingsPanel = ({ onSaved }) => {
  const { workspace, profile } = useRouteWorkspace();
  const isAdmin = profile?.role === 'admin';

  if (!workspace || !profile || !isAdmin) return null;

  return (
    <>
      <GeneralSettings workspace={workspace} onSaved={onSaved} />
      <div className="mt-8 pb-2">
        <WorkspaceBackgroundPicker
          workspace={workspace}
          profileId={profile.id}
          sessionKeyScope="workspace-settings-background-picker"
          dismissible={false}
          className="mx-auto"
        />
      </div>
    </>
  );
};

export default WorkspaceSettingsPanel;
